import AssistClasses from './AssistClasses.js'
import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import StepSetParameters from './StepSetParameters.js'
import StepPostList from './StepPostList.js'
import moment from 'moment'

class PostSelectType extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите вид рассылки',
      (step) => {
        return this.getPostTypeName(this.model.postTypeCode)
      },
      {
      },
      {
        postTypeCode: null,
        postListField: null
      }
    )
    this.context = cxt
    this.editable = true
    this.nextEnabled = () => {
      return ['FAVORITES', 'CSV'].includes(this.model['postTypeCode']) && (this.model['postListField'] !== null)
    }

  }
  fillFields (fields) {
    this.fields = fields
    var lScheme = []
    // var cxt = this.context
    lScheme.push({
      fieldType: 'v-select-radio',
      name: 'postTypeCode',
      itemText: 'text',
      itemValue: 'value',
      events: {
        'input': () => {
          this.model['postListField'] = null
        }
      },
      items: [
        {value: 'FAVORITES', text: 'Рассылка моим контрагентам'},
        {value: 'CSV', text: 'Рассылка по данным из файла'},
        {value: 'HOLDERS', text: 'Рассылка участникам компании (не реализована)'}
      ],
      size: {sm10: true}
    })
    lScheme.push({
      fieldType: 'v-flex',
      slot: `Укажите поле с уникальными значениями для формирования писем рассылки`,
      shrink: false,
      size: {sm8: true, xs12: true},
      if: (model, field) => ['FAVORITES', 'CSV'].includes(model['postTypeCode'])
    })
    lScheme.push({
      fieldType: 'v-select',
      label: 'Уникальное поле в рассылке',
      hint: 'Обычно содержит ИНН контрагента или Физ. Лица',
      itemValue: 'name',
      itemText: 'label',
      items: (model, field) => {
        if (['FAVORITES'].includes(model['postTypeCode'])) {
          return this.fields.filter(f => (!(/^\s*(self)\s*$/gi.test(f.value)) && (f.type.toUpperCase() === 'COMPANY')))
        }
        if (['CSV'].includes(model['postTypeCode'])) {
          return this.fields.filter(f => {
            return (!(/^\s*(self)\s*$/gi.test(f.value)) && (f.type.toUpperCase() === 'COMPANY') ||
            f.type.toUpperCase() === 'INDIVIDUAL' ||
            f.type.toUpperCase() === 'TEXT') && f.label
          })
        }
      },
      persistentHint: true,
      name: 'postListField',
      shrink: false,
      size: {sm8: true, xs12: true},
      if: (model, field) => ['FAVORITES', 'CSV'].includes(model['postTypeCode'])
    })
    this.props.scheme = lScheme
    return this
  }
  getPostTypeName (value) {
    var arr = [
      {value: 'FAVORITES', text: 'Рассылка моим контрагентам'},
      {value: 'HOLDERS', text: 'Рассылка участникам компании'},
      {value: 'CSV', text: 'Список значений'}
    ]
    var item = arr.find(i => i.value === value)
    return item ? item.text : null
  }
}

class DocumnentSelectType extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите тип документа',
      (step) => step.model.deedName,
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Тип',
            name: 'deedNumber',
            hint: (model, field) => {
              return model['deedName'] || 'Введите или выберите код типа документа'
            },
            errors: (model, field) => {
              return (model['deedNumber'] !== null) && (model['deedName'] === null) && 'Неверный код типа документа' || null
            },
            events: {
              'input': (value) => {
                cxt.setDeed('deedNumber', 'deedName', value)
              }
            },
            grow: true,
            size: {sm8: true, xs6: true}
          },
          {
            fieldType: 'v-btn',
            slot: 'Выбрать',
            events: {'click': () => cxt.selectDeed('deedNumber', 'deedName')},
            shrink: false,
            size: {sm4: true, xs6: true}
          },
          {
            fieldType: 'v-select',
            label: 'Формат документа',
            itemValue: 'value',
            itemText: 'text',
            items: (model, field) => {
              return cxt.getDeedFormats()
            },
            name: 'deedFormat',
            shrink: false,
            size: {sm8: true, xs12: true}
          }
        ]
      },
      {
        deedNumber: null,
        deedName: null,
        deedFormat: 'docx'
      }
    )
    this.context = cxt
    this.nextEnabled = () => this.model['deedName'] !== null
    this.editable = true
  }
}

class ChildrenSelect extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите документы для подшивки',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: []
      },
      {
        selectedChildren: null
      }
    )
    this.context = cxt
    this.editable = true
    this.childrenItems = []
  }
  fillChildren (items) {
    if (!items) {
      this.props.scheme = []
      return this
    }
    this.childrenItems = items
    let lScheme = [
      {
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: this.childrenItems,
        size: {sm10: true}
      }
    ]
    this.props.scheme = lScheme
    return this
  }
  fillSubTitle (model, fields) {
    return model['selectedChildren'] &&
    `Выбрано ${model['selectedChildren'].split(',').length} из ${this.childrenItems.length} документов` || ''
  }
}

class PostListSend extends AssistClasses.Step {
  constructor (cxt) {
    super(
      'Проверьте документы',
      (step) => (''),
      {
        scheme: []
      },
      {
      })
    this.context = cxt
    this.editable = true
  }
  fillFields (fields) {
    if (!fields) {
      this.props.scheme = []
      return this
    }
    var lScheme = []
    var cxt = this.context
    fields.forEach(f => {
      lScheme.push({
        fieldType: 'v-checkbox',
        name: f.name,
        label: f.label,
        hint: f.hint,
        persistentHint: true,
        grow: true,
        size: {sm8: true, xs6: true},
        if: (model, field) => {
          return !model[field.name]
        }
      })
      lScheme.push({
        fieldType: 'v-checkbox',
        inputValue: true,
        label: f.label,
        hint: f.hint,
        name: f.name,
        persistentHint: true,
        grow: true,
        size: {sm8: true, xs6: true},
        if: (model, field) => model[field.name]
      })
      lScheme.push({
        fieldType: 'v-btn',
        slot: 'Проверить',
        events: {'click': () => {
          cxt.print(null, f.name)
          this.model[f.name] = true
          this.model.setCurrentStep(cxt.currentStep)
          cxt.updateData(this.model)
        }
        },
        size: {sm4: true, xs6: true},
        shrink: false
      })
    })
    this.props.scheme = lScheme
    return this
  }
}

class DocumnentOperations extends AssistClasses.Step {
  static getOperations () {
    return [
      {value: 'DEPO', text: 'Подготовьте общий файл для рассылки'},
      {value: 'DOWNLOAD', text: 'Скачать депонированные документы'},
      {value: 'OPEN_DOC', text: 'Открыть карточку депонирования документов'},
      {value: 'SEND_BY_SERVER', text: 'Разослать документы по электронной почте'}
    ]
  }
  constructor (cxt) {
    super('Операции над рвссылкой',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: []
      },
      {
        '/email-send/options': 'DEPO_LINK',
        '/email-send/scheduledDate': null,
        '/email-send/scheduledTime': null,
        '/email-send/interval': 10
      }
    )
    this.context = cxt
    this.editable = true
    this.nextLabel = () => 'Выполнить'
  }
  fillSubTitle (model, fields) {
    if (model['depoLink']) {
      return this.context.getDepoUrl(model.depoLink)
    }
    if (model['deedNoContent']) {
      return 'Шаблон не предполагает документов'
    }
    return ''
  }
  fillFields () {
    let lScheme = [
      {
        fieldType: 'v-select-radio',
        name: 'lastOperation',
        itemText: 'text',
        itemValue: 'value',
        items: (model) => this.getOperations(model),
        size: {sm10: true}
      },
      {
        fieldType: 'v-date-field',
        label: 'Начало рассылки',
        hint: 'Укажите начало рассылки',
        name: '/email-send/scheduledDate',
        size: {sm4: true, xs6: true},
        if: (model, field) => model['lastOperation'] === 'SEND_BY_SERVER'
      },
      {
        fieldType: 'v-text-field',
        name: '/email-send/scheduledTime',
        placeholder: 'чч:мм',
        mask: '##:##',
        rules: [v => !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм'],
        size: {sm2: true, xs4: true},
        if: (model, field) => model['lastOperation'] === 'SEND_BY_SERVER'
      },
      {
        fieldType: 'v-text-field',
        label: 'Интервал, сек',
        name: '/email-send/interval',
        mask: '####',
        rules: [v => !v || v > 0 || 'сек. > 0'],
        size: {sm2: true, xs4: true},
        if: (model, field) => model['lastOperation'] === 'SEND_BY_SERVER'
      }
    ]
    this.props.scheme = lScheme
    return this
  }
  getOperations (model) {
    let ops = ['SEND_BY_SERVER', 'DEPO']
    if (model['depoLink']) {
      ops.push('OPEN_DOC', 'DOWNLOAD')
    }
    return DocumnentOperations.getOperations().filter(o => ops.includes(o.value))
  }
  next (model, cb) {
    this.execute(model)
    return model
  }
  execute (model) {
    var operation = model.lastOperation
    delete model.lastOperation
    switch (operation) {
      case 'DEPO':
        dialogs.confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?',
          (self) => {
            self.depoDoc('depoLink')
          })
        break
      case 'OPEN_DOC':
        if (model.depoLink) {
          this.context.openDoc('depoLink')
        } else {
          dialogs.message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий')
        }
        break
      case 'DOWNLOAD':
        if (model.depoLink) {
          this.context.openDepo(model.depoLink)
        } else {
          dialogs.message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий')
        }
        break
      case 'SEND_BY_SERVER':
        model.currentStep = 6
        this.context.updateData(model)
        if (this.context.getIsAllow({SEND_MAIL: null})) {
          let list = model.postList
          if (list) {
            let items = JSON.parse(list)
            let addresses = []
            let subjects = []
            let errors = []
            Object.entries(items).forEach(([k, v]) => {
              if (v['/email-send/to'] && formats.isEmail(v['/email-send/to'])) {
                addresses.push({key: k, email: v['/email-send/to']})
              } else {
                errors.push({key: k, err: v['/email-send/to']})
              }
              if (v['/email-send/subject']) {
                subjects.push(v['/email-send/subject'])
              }
            })
            if (errors.length === 0) {
              this.context.calcMailbox(model['/email-send/mailbox']).then((mailbox) => {
                let scheduled = null
                if (model['/email-send/scheduledDate'] || model['/email-send/scheduledTime']) {
                  let scheduledDate = model['/email-send/scheduledDate'] || moment().format('YYYY-MM-DD')
                  let scheduledTime = model['/email-send/scheduledTime'] || moment().format('HHmm')
                  scheduled = moment(`${scheduledDate} ${scheduledTime}`, 'YYYY-MM-DD HHmm', false)
                }
                if (!scheduled) {
                  scheduled = moment()
                }
                let subjectStr = subjects.length > 0 ? subjects[0] : model['/email-send/subject']
                let addressStr = addresses.map(i => `${i.key}: <b>${i.email}</b>`).join(', <br/>')
                dialogs.confirm(this, 'Подтвердите', `
                    Разослать письма "${subjectStr}" из почтового ящика: "${mailbox}" адресатам?
                    <br/>${addressStr}<br/>Письма рассылаются с ${scheduled.format('YYYY-MM-DD HH:mm')} интервал в ${model['/email-send/interval']} секунд.
                    <br/>К письмам прикрепляются актуальные версии документов из депозитария, 
                    если документ отсутствует он будет создан.`,
                (self) => {
                  let request = {
                    id: this.context.getMatterId(),
                    mailbox: mailbox,
                    scheduled: scheduled.format(),
                    interval: model['/email-send/interval']
                  }
                  this.context.$store.dispatch('sendAssistMatter', request)
                })
              })
            } else {
              let errorsStr = errors.map(i => `${i.key}: <b>${i.err ? i.err : '-'}</b>`).join(', <br/>')
              dialogs.message(this.context, 'Совет', `Перед отсылкой документов, необходимо задать правильные поля <b>эл. почты</b> адресатов.
                Используйте возможность загрузки данных из файла для задания адреса эл. почты. <br/>Ошибочные адреса:<br/>${errorsStr}.`)
            }
          }
        } else {
          dialogs.message(this.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании')
        }
        break
    }
  }
}

class Strategy extends AssistClasses.Strategy {
  getTypeCode () {
    return 'POST'
  }
  next (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      currentStep = currentStep <= this.steps.length ? currentStep + 1 : this.steps.length + 1
      model.setCurrentStep(currentStep)
      this.context.updateData(model)
      return model
    }
    return step && step.next ? step.next(model, cb) : model
  }
  getCurrentStep (model) {
    return this.steps.find(step => step.number === model.getCurrentStep())
  }
  back (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      if (currentStep > 1) {
        currentStep = currentStep - 1
        model.setCurrentStep(currentStep)
        this.context.updateData(model)
      } else {
        this.context.refreshData()
      }
      return model
    }
    return step && step.back ? step.back(model, cb) : model
  }

  complete (model, step) {
    return step && model && model.getCurrentStep() > step.number
  }

  editable (model, step) {
    return step.editable || (model && model.getCurrentStep() === step.number)
  }

  updateSteps (scheme) {
    var steps = []
    var cxt = this.context
    Object.assign(new DocumnentSelectType(cxt), {backLabel: () => 'Отмена'})
    .addToArray(steps)

    if (scheme && scheme.steps && scheme.steps.length > 0 && scheme.steps[0].fields.length > 0) {
      new ChildrenSelect(cxt)
      .fillChildren(scheme.steps[0].fields)
      .addToArray(steps)
    }

    if (scheme && scheme.steps && scheme.steps.length > 1) {
      new StepSetParameters.Step(cxt)
      .fillFields(scheme.steps[1].fields)
      .addToArray(steps)

      new PostSelectType(cxt)
      .fillFields(scheme.steps[1].fields)
      .addToArray(steps)

      new StepPostList.Step(cxt)
      .fillFields(scheme.steps[1].fields)
      .addToArray(steps)

      if (scheme.steps.length > 2) {
        new PostListSend(cxt)
        .fillFields(scheme.steps[2].fields)
        .addToArray(steps)
      }

      // if (scheme.steps.length > 2) {
      //   new DocumnentCheck(cxt)
      //   .addToArray(steps)
      // }

      if (scheme.steps.length > 2) {
        new DocumnentOperations(cxt)
        .fillFields()
        .addToArray(steps)
      }
    }

    this.steps = steps
    return this
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }
  createModel () {
    var model = new Model()
    if (this.context) {
      model['companyInn'] = this.context.profile.clientInn
    }
    this.steps.forEach((step) => Object.assign(model, step.model))
    return model
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

class Model extends AssistClasses.Model {
  constructor () {
    super()
    // this.companyInn = null
    this.deedNumber = null
    this.deedNoContent = false
  }

  copy () {
    return Object.assign(new Model(), this)
  }

}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/assist/PostSteps.js